import Main from "../components/main";
export default function HomePage() {
  return <Main />;
}
